/* eslint-disable @stylistic/quotes */

/**
 * Default date format used for displaying dates in the application.
 * Format: 'MM/dd/yyyy' (e.g., 12/31/2024)
 */

export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';

/**
 * Default format string for parsing date-time values.
 * Format: "yyyy-MM-dd'T'HH:mm:ss" (e.g., 2024-12-31T23:59:59)
 */
export const DEFAULT_PARSE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

/**
 * Default format string for parsing date-time values with microseconds precision.
 * Format: "yyyy-MM-dd'T'HH:mm:ss.SSSSSS" (e.g., 2024-12-31T23:59:59.1234567)
 */
export const DEFAULT_PARSE_FORMAT_WITH_MICROSECONDS = "yyyy-MM-dd'T'HH:mm:ss.SSSSSSS";
